<template>
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
      :backButton="true"
      :prevRoutePath="backUrl"
    />
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-body">
            <form-wizard color="#0067AC" ref="formwizard" :hide-buttons="true">
              <!-- WIZARD 1 - basic target profile -->
              <tab-content
                icon="mdi mdi-account-circle"
              >
                <tab-1 :doValidation="doValidation1" :idTarget="id_target" @id-target="setIdTarget" @id-category="setIdCategory" @target-title="setTargetTitle" @next-tab="nextTab" @validation-failed="validation1Failed"></tab-1>
                <div class="d-flex justify-content-end mt-3">
                  <b-button variant="primary" @click="validation1">Next
                    <i
                      class="bx bx-chevron-right font-size-16 align-middle"
                    ></i>
                  </b-button>
                </div>
              </tab-content>
              <!-- WIZARD 1 - basic target profile -->

              <!-- WIZARD 2 - citizen profile -->
              <tab-content icon="mdi mdi-database-import">
                <tab-2 :doValidation="doValidation2" :idTarget="id_target" @id-target="setIdTarget" @next-tab="nextTab" @validation-failed="validation2Failed"></tab-2>
                <div class="d-flex justify-content-between mt-3">
                  <b-button
                    variant="primary"
                    @click="prevTab"
                  >
                    <i class="bx bx-chevron-left font-size-16 align-middle"></i>
                    Previous
                  </b-button>
                  <b-button
                    variant="primary"
                    @click="validation2"
                  >
                    Next
                    <i
                      class="bx bx-chevron-right font-size-16 align-middle"
                    ></i>
                  </b-button>
                </div>
              </tab-content>
              <!-- WIZARD 2 -->

              <!-- WIZARD 3 - social media hunter -->
              <tab-content
                icon="mdi mdi-crosshairs-gps"
              >
                <tab-3 :doValidation="doValidation3" :idTarget="id_target" @id-target="setIdTarget" @next-tab="nextTab" @validation-failed="validation3Failed"></tab-3>
                <div class="d-flex justify-content-between mt-3">
                  <b-button
                    variant="primary"
                    @click="prevTab"
                  >
                    <i class="bx bx-chevron-left font-size-16 align-middle"></i>
                    Previous
                  </b-button>
                  <b-button
                    variant="primary"
                    @click="validation3"
                  >
                    Next
                    <i
                      class="bx bx-chevron-right font-size-16 align-middle"
                    ></i>
                  </b-button>
                </div>
              </tab-content>
              <!-- WIZARD 3 -->

              <!-- WIZARD 4 - finish -->
              <tab-content icon="mdi mdi-checkbox-marked-circle">
                <tab-4 :doValidation="doValidation4" :idTarget="id_target" :idCategory="id_category" :titleTarget="title_target" @id-target="setIdTarget" @next-tab="nextTab" @validation-failed="validation4Failed"></tab-4>
                <div class="d-flex justify-content-between mt-3">
                  <b-button
                    variant="primary"
                    @click="prevTab"
                  >
                    <i class="bx bx-chevron-left font-size-16 align-middle"></i>
                    Previous
                  </b-button>
                  <b-button
                    variant="primary"
                    @click="validation4"
                  >
                    Finish
                    <i
                      class="bx bx-chevron-right font-size-16 align-middle"
                    ></i>
                  </b-button>
                </div>
              </tab-content>
              <!-- WIZARD 4 -->

              <!-- Custom Button -->
              <!-- <div
                slot="footer"
                class="d-flex"
                :class="
                  props.activeTabIndex != 0
                    ? 'justify-content-between'
                    : 'justify-content-end'
                "
                slot-scope="props"
              >
                <b-button
                  class="d-flex align-items-center"
                  variant="primary"
                  @click="props.prevTab()"
                  v-if="props.activeTabIndex != 0"
                >
                  <i
                    class="
                      fas
                      fa-angle-double-left
                      font-size-16
                      align-middle
                      mr-1
                    "
                  ></i>
                  Prev
                </b-button>
                <div
                  v-if="props.activeTabIndex != 3"
                  class="d-flex align-items-center"
                >
                  <div v-if="loadingProcess">
                    <span
                      v-if="statusProcess == 'process'"
                      class="text-secondary font-weight-bold mr-2"
                      >{{ messageProcess }}</span
                    >
                    <span
                      v-if="statusProcess != 'process'"
                      :class="
                        statusProcess == true ? 'text-success' : 'text-danger'
                      "
                      class="font-weight-bold mr-2"
                      >{{ messageProcess }}</span
                    >
                    <i
                      v-if="statusProcess == 'process'"
                      class="mdi mdi-access-point mdi-spin mdi-18px mr-2"
                    ></i>
                    <i
                      v-if="statusProcess != 'process'"
                      :class="
                        statusProcess == true
                          ? 'mdi-progress-check text-success'
                          : 'mdi-progress-close text-danger'
                      "
                      class="mdi mdi-18px mr-2"
                    ></i>
                  </div>
                  <b-button
                    class="d-flex align-items-center"
                    variant="primary"
                    v-if="props.activeTabIndex != 3"
                    @click="props.nextTab()"
                  >
                    Next
                    <i
                      class="
                        fas
                        fa-angle-double-right
                        font-size-16
                        align-middle
                        ml-1
                      "
                    ></i>
                  </b-button>
                </div>
                <div
                  v-if="props.activeTabIndex == 3"
                  class="d-flex align-items-center"
                >
                  <div v-if="loadingProcess">
                    <span
                      v-if="statusProcess == 'process'"
                      class="text-secondary font-weight-bold mr-2"
                      >{{ messageProcess }}</span
                    >
                    <span
                      v-if="statusProcess != 'process'"
                      :class="
                        statusProcess == true ? 'text-success' : 'text-danger'
                      "
                      class="font-weight-bold mr-2"
                      >{{ messageProcess }}</span
                    >
                    <i
                      v-if="statusProcess == 'process'"
                      class="mdi mdi-access-point mdi-spin mdi-18px mr-2"
                    ></i>
                    <i
                      v-if="statusProcess != 'process'"
                      :class="
                        statusProcess == true
                          ? 'mdi-progress-check text-success'
                          : 'mdi-progress-close text-danger'
                      "
                      class="mdi mdi-18px mr-2"
                    ></i>
                  </div>
                  <b-button
                    class="d-flex align-items-center"
                    variant="primary"
                    :disabled="disableFinish"
                    v-if="props.activeTabIndex == 3"
                    @click="finishWizard()"
                  >
                    Finish
                    <i class="fas fa-check font-size-16 align-middle ml-1"></i>
                  </b-button>
                </div>
              </div> -->
              <!-- Custom Button -->
            </form-wizard>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>

      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import Vue from "vue";
import Layout from "../../../layouts/main";
import Citizen from "../../citizen/citizen.vue";
import Particle from "./particle.vue";
import Spin from "./3dspinner.vue";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import VueSlideBar from "vue-slide-bar";
import CitizenService from "@/helpers/citizen.service";
import { required } from "vuelidate/lib/validators";
import CategoryService from "@/helpers/category.service";
import UserService from "@/helpers/user.service";
import SherlockService from "@/helpers/sherlock.service";
import moment from "moment";
import TargetService from "@/helpers/target-profile.service";
import SocmedService from "@/helpers/socmed.service";
import TwintService from "@/helpers/twint.service";
import { gmapApi } from "vue2-google-maps";
import PhoneService from "@/helpers/phone.service";
import WebsiteService from "@/helpers/website.service.js";
import PreferenceService from "@/helpers/preference.service.js";
import Swal from "sweetalert2";

import Tab1 from "./tab-personal/tab1.vue";
import Tab2 from "./tab-personal/tab2.vue";
import Tab3 from "./tab-personal/tab3.vue";
import Tab4 from "./tab-personal/tab4.vue";

/**
 * Form wizard component
 */
export default {
  page: {
    title: "Form Wizard",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Particle,
    Spin,
    VueSlideBar,
    Layout,
    PageHeader,
    FormWizard,
    TabContent,
    Citizen,
    Tab1,
    Tab2,
    Tab3,
    Tab4,
  },
  data() {
    return {
      backUrl: "/project/template",
      url_image:
        process.env.VUE_APP_BASE_API_URL + "target/image-project?name=",
      detailTarget: [],
      options: [],
      dataResult: [],
      selectedMedsos: [],
      selectedOtherMedsos: [],
      search: "",
      searchCitizen: false,
      error: "",
      value: [],
      show: false,
      category: [],
      users: [],
      search_value: 0,
      fileValid: true,
      title: this.$t("wizard.profiling.text"),
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: this.$t("overview.project.text"),
          href: "/project",
        },
        {
          text: this.$t("wizard.form.title.add-profile-target"),
          active: true,
        },
      ],
      form: {
        wizard1: {
          title: "",
          description: "",
          other_description: "",
          relation: [],
          image_project: null,
          manager: "",
          category: "",
          status: 1,
        },
        wizard2: {
          nama: "",
          nik: "",
          nkk: "",
          alamat: "",
          tanggal_lahir: "",
          tempat_lahir: "",
        },
        sosmed: {
          instagram: "",
          twitter: "",
          facebook: "",
          telegram: "",
          tiktok: "",
        },
        telephone: "",
        website: "",
      },
      valid: true,
      submitted: false,
      submitform: false,
      submit: false,
      typesubmit: false,
      tableData: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      loading: false,
      selectedItem: [],
      geocoder: null,
      citizen_lat: 0,
      citizen_long: 0,
      phoneinfo: [],
      validformat: null,
      screen: {
        width: 0,
        height: 0,
      },
      fields: [
        { key: "nama", label: "Name", sortable: true },
        { key: "nik", label: "NIK", sortable: true },
        { key: "nkk", label: "NKK", sortable: true },
        { key: "tempat_lahir", label: "Birth Place", sortable: true },
        { key: "tanggal_lahir", label: "Date of Birth", sortable: true },
        { key: "actions", label: "Action" },
      ],
      wizard_validation: {
        invalid: false,
        status: "not sent",
        id_record: "",
      },
      wizard_validation2: {
        status: "not sent",
        id_record: "",
      },
      wizard_validation3: {
        status: "not sent",
        id_twitter: "",
        id_facebook: "",
        id_tiktok: "",
        id_telegram: "",
        id_instagram: "",
        id_other: [],
        sites_name: [],
      },
      wizard_validation4: {
        id_private_data: "",
      },
      searchResultWebinfo: "",
      searchResultWhois: "",
      searchResultIpLocation: "",
      searchResultService: "",
      searchResultCms: "",
      searchResultSubDomain: "",
      domainSearch: "",
      idWebInfo: "",
      idWhois: "",
      idIp: "",
      idWebService: "",
      idCms: "",
      idPrivateWeb: "",
      statusProcess: "",
      messageProcess: "",
      loadingProcess: "",
      disableFinish: false,
      elastic: "",
      similar: [],
      doValidation1 : false,
      doValidation2 : false,
      doValidation3 : false,
      doValidation4 : false,
      id_target: "",
      id_category: "",
      title_target: "",
    };
  },

  computed: {
    google: gmapApi,
    rows() {
      return this.tableData.length;
    },
    criteria() {
      return this.search.trim().toLowerCase();
    },
    availableOptions() {
      const criteria = this.criteria;
      let element = [];
      try {
        for (let i = 0; i < this.form.wizard1.relation.length; i++) {
          element.push(JSON.parse(this.form.wizard1.relation[i]).id);
        }
      } catch (e) {
        element = [];
      }
      const options = this.options.filter(
        (opt) => element.indexOf(opt.id) === -1
      );
      this.show = false;
      if (criteria) {
        this.show = true;
        return options.filter((opt) =>
          opt.name.toLowerCase().includes(criteria)
        );
      }
      return options;
    },
    searchDesc() {
      if (this.criteria && this.availableOptions.length === 0) {
        return this.$t("wizard.form.validation.not_match1");
      }
      return "";
    },
    validFormat() {
      if (this.validformat != null) {
        if (this.validformat) {
          return "is-valid";
        } else {
          return "is-invalid";
        }
      }
    },
  },

  validations: {
    form: {
      wizard1: {
        title: { required },
        description: { required },
        other_description: {},
        manager: { required },
        relation: {},
        image_project: {},
        category: { required },
      },
      wizard2: {
        nama: { required },
        nik: {},
        nkk: {},
        alamat: {},
        tanggal_lahir: {},
        tempat_lahir: {},
      },
      search: {},
      instagram: {},
      twitter: {},
      facebook: {},
      telegram: {},
      url: {},
      telephone: {},
      website: {},
    },
  },

  methods: {
    onInputTitle() {
      if (this.form.wizard1.title != "") {
        const dataBody = {
          title: this.form.wizard1.title,
        };
        TargetService.checkSimilar(dataBody)
          .then((response) => {
            this.similar = response.data.data;
          })
          .catch((err) => {
            this.similar = [];
            console.log(err);
          });
      }
    },

    nextTab() {
      // this.loading.process = false;
      this.$refs.formwizard.nextTab();
    },
    prevTab() {
      this.$refs.formwizard.prevTab();
    },

    setIdTarget(id){
      this.id_report = id; 
    },
    
    setIdCategory(val){
      this.id_category = val; 
    },
    
    setTargetTitle(val){
      this.target_title = val; 
    },

    validation1(){
      this.doValidation1 = true;
      setTimeout(() => {
        this.doValidation1 = false;
      }, 1000);
    },

    validation1Failed(){
      console.log("Wizard 1 Failed");
    },

    validation2(){
      this.doValidation2 = true;
      setTimeout(() => {
        this.doValidation2 = false;
      }, 1000);
    },

    validation2Failed(){
      console.log("Wizard 2 Failed");
    },

    validation3(){
      this.doValidation3 = true;
      setTimeout(() => {
        this.doValidation3 = false;
      }, 1000);
    },

    validation3Failed(){
      console.log("Wizard 3 Failed");
    },

    validation4(){
      this.doValidation4 = true;
      setTimeout(() => {
        this.doValidation4 = false;
      }, 1000);
    },

    validation4Failed(){
      console.log("Wizard 4 Failed");
    },

    //================================== wizard 1 ===================================//
    /* =======================================
         get all target for input relation profile
         =======================================
      */
    listProfile() {
      TargetService.getAllTarget()
        .then((response) => {
          response.data.data.forEach((val) => {
            const opt = {
              name: val.title,
              id: val.id_target,
              image: val.image_project,
            };
            this.options.push(opt);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onOptionClick({ option, addTag }) {
      this.form.wizard1.relation.push({
        name: option.name,
        id: option.id,
        image: option.image,
      });
      this.show = false;
      this.search = "";
    },
    /** ======================================*/

    /* =======================================
         upload image and filter max size
         =======================================
      */
    upImage(evt) {
      const fileSize = evt.target.files[0].size / 1024 / 1024;
      if (fileSize > 2) {
        this.fileValid = false;
      } else {
        this.fileValid = true;
        this.form.wizard1.image_project = evt.target.files[0];
      }
    },
    /** ======================================*/

    /* =======================================
         get all category and user where type manager
         =======================================
      */
    getCategory() {
      CategoryService.list()
        .then((response) => {
          this.category = response.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getUser() {
      UserService.getAllManager()
        .then((response) => {
          this.users = [];
          response.data.data.forEach((val) => {
            const data = {
              id_user: val.id_user,
              username: val.username,
              user_type: val.user_type,
            };
            this.users.push(data);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /** ======================================*/

    /* =======================================
         save basic information of target
         =======================================
      */
    async saveBasicTarget() {
      this.wizard_validation.invalid = this.$v.form.wizard1.$invalid;
      this.submitted = true;
      this.$v.form.wizard1.$touch();
      if (
        !this.wizard_validation.invalid &&
        this.wizard_validation.status == "not sent"
      ) {
        this.loadingProcess = true;
        this.statusProcess = "process";
        this.messageProcess = "Saving basic information target ..";
        const formCreate = new FormData();
        formCreate.append("title", this.form.wizard1.title);
        formCreate.append("description", this.form.wizard1.description);
        formCreate.append(
          "other_description",
          this.form.wizard1.other_description
        );
        formCreate.append("manager", this.form.wizard1.manager);
        formCreate.append("id_category", this.form.wizard1.category);
        formCreate.append("category_score", 0);
        formCreate.append("status_id", this.form.wizard1.status);
        formCreate.append("relation_profile", this.form.wizard1.relation);
        if (this.form.wizard1.image_project != null) {
          formCreate.append(
            "image_project",
            this.form.wizard1.image_project,
            this.form.wizard1.image_project.name
          );
        }
        await TargetService.create(formCreate)
          .then((response) => {
            this.wizard_validation.status = "sent";
            this.wizard_validation.id_record = response.data.data.id_target;
            this.statusProcess = true;
            this.messageProcess = "Success saving target";
            setTimeout(() => {
              this.loadingProcess = false;
            }, 500);
          })
          .catch((err) => {
            this.statusProcess = false;
            this.messageProcess = "Failed saving target";
            setTimeout(() => {
              this.loadingProcess = false;
            }, 500);
            console.log(err);
          });
      } else if (
        !this.wizard_validation.invalid &&
        this.wizard_validation.status == "sent"
      ) {
        this.loadingProcess = true;
        this.statusProcess = "process";
        this.messageProcess = "Updating basic information target ..";
        const formUpdate = new FormData();
        formUpdate.append("title", this.form.wizard1.title);
        formUpdate.append("description", this.form.wizard1.description);
        formUpdate.append(
          "other_description",
          this.form.wizard1.other_description
        );
        formUpdate.append("manager", this.form.wizard1.manager);
        formUpdate.append("id_category", this.form.wizard1.category);
        formUpdate.append("category_score", 0);
        formUpdate.append("status_id", this.form.wizard1.status);
        formUpdate.append("relation_profile", this.form.wizard1.relation);
        if (this.form.wizard1.image_project != null) {
          formUpdate.append(
            "image_project",
            this.form.wizard1.image_project,
            this.form.wizard1.image_project.name
          );
        }
        await TargetService.update(this.wizard_validation.id_record, formUpdate)
          .then((response) => {
            this.wizard_validation.status = "sent";
            this.statusProcess = true;
            this.messageProcess = "Success updating target";
            setTimeout(() => {
              this.loadingProcess = false;
            }, 500);
          })
          .catch((err) => {
            this.statusProcess = false;
            this.messageProcess = "Failed updating target";
            setTimeout(() => {
              this.loadingProcess = false;
            }, 500);
            console.log(err);
          });
      }
      return this.wizard_validation.invalid;
    },
    /** ======================================*/
    /* =======================================
         validation next button wizard 1
         =======================================
      */
    validationWizard: async function (tab) {
      let flag = false;
      let result = await this.saveBasicTarget();
      this.refreshSlider();
      await new Promise((resolve, reject) => {
        if (result) {
          flag = false;
          reject("invalid");
        } else {
          setTimeout(function () {
            flag = true;
            resolve("valid");
          }, 1500);
        }
      }).then();
      return flag;
    },
    /** ======================================*/
    //================================== wizard 1 ===================================//

    //================================== wizard 2 ===================================//
    /* =======================================
         setup datatable & validation input parameters citizen
         =======================================
      */
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    checkInput() {
      this.submitted = true;
      this.$v.form.wizard2.$touch();
      if (
        (this.form.wizard2.nama == "" &&
          this.form.wizard2.nik == "" &&
          this.form.wizard2.nkk == "" &&
          this.form.wizard2.alamat == "" &&
          this.form.wizard2.tanggal_lahir == "" &&
          this.form.wizard2.tempat_lahir == "") ||
        this.$v.form.wizard2.$invalid
      ) {
        this.valid = false;
      } else {
        this.valid = true;
      }
    },
    /** ======================================*/

    /* =======================================
         search citizen data
         =======================================
      */
    searchData() {
      this.error = "";
      this.searchCitizen = true;
      let query;
      let data = {
        size: this.search_value,
        query: {
          bool: {
            filter: [
              {
                bool: {
                  filter: [],
                },
              },
            ],
          },
        },
      };
      if (data.query.bool.filter[0].bool.filter.length != 0) {
        data.query.bool.filter[0].bool.filter.push([]);
      }
      if (this.form.wizard2.nama != "") {
        const key = this.form.wizard2.nama.split(" ");
        for (let i = 0; i < key.length; i++) {
          query = {
            bool: {
              should: [{ match_phrase: { nama: key[i] } }],
              minimum_should_match: 1,
            },
          };
          data.query.bool.filter[0].bool.filter.push(query);
        }
      }
      if (this.form.wizard2.nik != "") {
        query = {
          bool: {
            should: [{ match_phrase: { nik: this.form.wizard2.nik } }],
            minimum_should_match: 1,
          },
        };
        data.query.bool.filter[0].bool.filter.push(query);
      }
      if (this.form.wizard2.nkk != "") {
        query = {
          bool: {
            should: [{ match_phrase: { nkk: this.form.wizard2.nkk } }],
            minimum_should_match: 1,
          },
        };
        data.query.bool.filter[0].bool.filter.push(query);
      }
      if (this.form.wizard2.alamat != "") {
        query = {
          bool: {
            should: [{ match_phrase: { alamat: this.form.wizard2.alamat } }],
            minimum_should_match: 1,
          },
        };
        data.query.bool.filter[0].bool.filter.push(query);
      }
      if (this.form.wizard2.tanggal_lahir != "") {
        query = {
          bool: {
            should: [
              {
                range: {
                  tanggal_lahir: {
                    gte: this.formatDate(this.form.wizard2.tanggal_lahir),
                    lte: this.formatDate(this.form.wizard2.tanggal_lahir),
                    time_zone: "Asia/Jakarta",
                  },
                },
              },
            ],
            minimum_should_match: 1,
          },
        };
        data.query.bool.filter[0].bool.filter.push(query);
      }
      if (this.form.wizard2.tempat_lahir != "") {
        query = {
          bool: {
            should: [
              {
                match_phrase: { tempat_lahir: this.form.wizard2.tempat_lahir },
              },
            ],
            minimum_should_match: 1,
          },
        };
        data.query.bool.filter[0].bool.filter.push(query);
      }

      this.checkInput();
      if (this.valid) {
        this.loading = true;
        this.resetTable();
        CitizenService.search(this.elastic, data)
          .then((response) => {
            this.resetTable();
            response.data.hits.hits.forEach((val) => {
              const data = {
                nama: val._source.nama,
                nik: val._source.nik,
                nkk: val._source.nkk,
                tempat_lahir: val._source.tempat_lahir,
                tanggal_lahir: val._source.tanggal_lahir,
                jenis_kelamin: val._source.jenis_kelamin,
                alamat: val._source.alamat,
                jenis_kelamin: val._source.jenis_kelamin,
                kawin: val._source.kawin,
                pekerjaan: val._source.pekerjaan,
              };
              this.tableData.push(data);
              this.loading = false;
            });
          })
          .catch((err) => {
            if (err.response.status == 500) {
              this.error = "Internal server Error";
            } else if (err.response.status == 404) {
              this.error = "Server Not Found";
            } else if (err.response.status == 403) {
              this.error = "Forbidden";
            }
          });
        setTimeout(() => {
          this.loading = false;
        }, 2000);
      }
    },
    /** ======================================*/

    /* =======================================
         save citizen data
         =======================================
      */
    async saveCitizen() {
      let result = false;
      if (this.selectedItem != 0) {
        if (
          !this.wizard_validation2.invalid &&
          this.wizard_validation2.status == "not sent"
        ) {
          this.loadingProcess = true;
          this.statusProcess = "process";
          this.messageProcess = "Saving citizen data target ..";
          const formCreate = new FormData();
          formCreate.append("name", this.selectedItem[0].nama);
          formCreate.append("nik", this.selectedItem[0].nik);
          formCreate.append("nkk", this.selectedItem[0].nkk);
          formCreate.append("birth_place", this.selectedItem[0].tempat_lahir);
          formCreate.append(
            "date_of_birth",
            this.selectedItem[0].tanggal_lahir
          );
          formCreate.append("gender", this.selectedItem[0].jenis_kelamin);
          formCreate.append("address", this.selectedItem[0].alamat);
          formCreate.append("marriage_status", this.selectedItem[0].kawin);
          formCreate.append("profession", this.selectedItem[0].pekerjaan);
          await CitizenService.create(formCreate)
            .then((response) => {
              this.wizard_validation2.id_record = response.data.data.id_citizen;
              this.statusProcess = true;
              const dataUpdate = new FormData();
              dataUpdate.append("id_citizen", response.data.data.id_citizen);
              this.updateTarget(dataUpdate);
              this.wizard_validation2.status = "sent";
              this.messageProcess = "Success saving citizen data";
              setTimeout(() => {
                this.loadingProcess = false;
              }, 500);
            })
            .catch((err) => {
              this.statusProcess = false;
              this.messageProcess = "Failed saving citizen data";
              setTimeout(() => {
                this.loadingProcess = false;
              }, 500);
              console.log(err);
            });
          await (result = true);
        } else if (
          !this.wizard_validation2.invalid &&
          this.wizard_validation2.status == "sent"
        ) {
          this.loadingProcess = true;
          this.statusProcess = "process";
          this.messageProcess = "Updating citizen data target ..";
          const formUpdate = new FormData();
          formUpdate.append("name", this.selectedItem[0].nama);
          formUpdate.append("nik", this.selectedItem[0].nik);
          formUpdate.append("nkk", this.selectedItem[0].nkk);
          formUpdate.append("birth_place", this.selectedItem[0].tempat_lahir);
          formUpdate.append(
            "date_of_birth",
            this.selectedItem[0].tanggal_lahir
          );
          formUpdate.append("gender", this.selectedItem[0].jenis_kelamin);
          formUpdate.append("address", this.selectedItem[0].alamat);
          formUpdate.append("marriage_status", this.selectedItem[0].kawin);
          formUpdate.append("profession", this.selectedItem[0].pekerjaan);
          await CitizenService.update(
            this.wizard_validation.id_record,
            formUpdate
          )
            .then((response) => {
              this.wizard_validation2.status = "sent";
              this.statusProcess = true;
              this.messageProcess = "Success updating citizen data";
              setTimeout(() => {
                this.loadingProcess = false;
              }, 500);
            })
            .catch((err) => {
              this.statusProcess = false;
              this.messageProcess = "Failed updating citizen data";
              setTimeout(() => {
                this.loadingProcess = false;
              }, 500);
              console.log(err);
            });
          await (result = true);
        }
      }
      return result;
    },
    /** ======================================*/

    /* =======================================
         handling for select citizen data
         =======================================
      */
    selectCitizen(item) {
      this.selectedItem = [];
      this.selectedItem.push(item);
      this.form.wizard2.nama = item.nama;
      this.form.wizard2.nik = item.nik;
      this.form.wizard2.nkk = item.nkk;
      this.form.wizard2.alamat = item.alamat;
      this.form.wizard2.tanggal_lahir = item.tanggal_lahir;
      this.form.wizard2.tempat_lahir = item.tempat_lahir;
    },
    /** ======================================*/

    /* =======================================
         open map modal and show location of citizen address
         =======================================
      */
    openMapsModal(id, alamat) {
      this.geocoder.geocode({ address: alamat }, (results, status) => {
        this.citizen_lat = results[0].geometry.location.lat();
        this.citizen_long = results[0].geometry.location.lng();
      });
      this.$bvModal.show("modal-maps" + id);
    },
    /** ======================================*/

    /* =======================================
          validation next button wizard 2
          =======================================
      */
    validationWizard2: async function (tab) {
      let flag = false;
      let result = await this.saveCitizen();
      await new Promise((resolve, reject) => {
        setTimeout(function () {
          flag = true;
          resolve("valid");
        }, 1500);
      }).then();
      return flag;
    },
    /** ======================================*/
    //================================== wizard 2 ===================================//

    //================================== wizard 3 ===================================//
    /* =======================================
         search media social by username (sherlock)
         =======================================
      */
    searchMediaSosial() {
      let skey = this.$refs.searchKey;
      this.dataResult = [];
      if (skey.value !== "") {
        const data = {
          option: "--timeout 1",
          username: skey.value,
        };
        this.loading = true;
        SherlockService.search(data)
          .then((response) => {
            this.dataResult.push(response.data.output);
            this.loading = false;
          })
          .catch((err) => {
            this.loading = false;
          });
      } else {
        this.dataResult = "";
      }
    },
    /** ======================================*/

    /* =======================================
         handling select and unselect social media 
         =======================================
      */
    setSelectMedsos(site, link, username, index, indexusr) {
      const data = {
        site: site,
        link: link,
        username: username,
        idx: indexusr + "-" + index,
      };
      this.dataResult[0][indexusr].result[index].active = true;
      if (this.selectedMedsos != 0) {
        for (let i = 0; i < this.selectedMedsos.length; i++) {
          if (this.selectedMedsos[i].site == site) {
            this.selectedMedsos.splice(i, 1);
          }
        }
      }
      this.selectedMedsos.push(data);
    },
    unsetSelectMedsos(index, idx) {
      let idx_split = idx.split("-");
      this.selectedMedsos.splice(index, 1);
      this.dataResult[0][idx_split[0]].result[idx_split[1]].active = false;
    },
    /** ======================================*/

    /* =======================================
         handle for saving selected media
         =======================================
      */
    async saveMedia() {
      if (
        this.selectedMedsos != 0 &&
        this.wizard_validation3.status == "not sent"
      ) {
        console.log("asdsa");
        this.loadingProcess = true;
        this.statusProcess = "process";
        this.messageProcess = "Saving social media target ..";
        for (let i = 0; i < this.selectedMedsos.length; i++) {
          await this.saveMediaByType(
            this.selectedMedsos[i].site,
            this.selectedMedsos[i].username,
            this.selectedMedsos[i].link
          );
        }
      } else if (
        this.selectedMedsos != 0 &&
        this.wizard_validation3.status == "sent"
      ) {
        for (let i = 0; i < this.selectedMedsos.length; i++) {
          await this.updateMediaByType(
            this.selectedMedsos[i].site,
            this.selectedMedsos[i].username,
            this.selectedMedsos[i].link
          );
        }
      }
      return true;
    },
    saveMediaByType(site, username, link) {
      if (site == "Twitter") {
        const args = {
          args: username,
        };
        console.log("twitterrrr");
        this.statusProcess = "process";
        this.messageProcess = "Scrapping data for twitter ...";
        TwintService.getUser(args)
          .then((response) => {
            if (response.status == 200) {
              const tw = {
                account: response.data.output.screen_name,
                user_id: response.data.output.user_id,
                name: response.data.output.name,
                avatar: response.data.output.avatar,
                followers: response.data.output.followers,
                following: response.data.output.following,
                tweets: response.data.output.tweets,
                location: response.data.output.location,
                bio: response.data.output.bio,
                likes: response.data.output.likes,
                media: response.data.output.media,
                favorites: response.data.output.favorites,
                is_private: response.data.output.private,
                is_verified: response.data.output.verified,
                join_at: response.data.output.created_at,
              };
              SocmedService.createTwitter(tw)
                .then((response) => {
                  this.wizard_validation3.status = "sent";
                  this.wizard_validation3.id_twitter =
                    response.data.data.id_twitter;
                  this.form.sosmed.twitter = response.data.data.account;
                  this.statusProcess = true;
                  this.messageProcess = "Success saving data twitter";
                })
                .catch((err) => {
                  this.statusProcess = false;
                  this.messageProcess = "Failed saving data twitter";
                  console.log(err);
                })
                .finally(() => {
                  this.updateMediaTarget();
                });
            }
          })
          .catch((err) => {
            this.statusProcess = false;
            this.messageProcess = "Failed scrapping data for twitter ...";
            console.log(err);
          })
          .finally();
      } else if (site == "Facebook") {
        const fb = { account: username };
        this.statusProcess = "process";
        this.messageProcess = "Scrapping data for facebook ...";
        SocmedService.createFacebook(fb)
          .then((response) => {
            this.wizard_validation3.status = "sent";
            this.wizard_validation3.id_facebook =
              response.data.data.id_facebook;
            this.form.sosmed.facebook = response.data.data.account;
            this.statusProcess = true;
            this.messageProcess = "Success saving data facebook";
          })
          .catch((err) => {
            this.statusProcess = false;
            this.messageProcess = "Failed saving data facebook";
            console.log(err);
          })
          .finally(() => {
            this.updateMediaTarget();
          });
      } else if (site == "Instagram") {
        const ig = { account: username };
        this.statusProcess = "process";
        this.messageProcess = "Scrapping data for instagram ...";
        SocmedService.createInstagram(ig)
          .then((response) => {
            this.wizard_validation3.status = "sent";
            this.wizard_validation3.id_instagram =
              response.data.data.id_instagram;
            this.form.sosmed.instagram = response.data.data.account;
            this.statusProcess = true;
            this.messageProcess = "Success saving data instagram ...";
          })
          .catch((err) => {
            this.statusProcess = false;
            this.messageProcess = "Failed saving data instagram ...";
            console.log(err);
          })
          .finally(() => {
            this.updateMediaTarget();
          });
      } else if (site == "TikTok") {
        const tk = { account: username };
        this.statusProcess = "process";
        this.messageProcess = "Scrapping data for tiktok ...";
        SocmedService.createTiktok(tk)
          .then((response) => {
            this.wizard_validation3.status = "sent";
            this.wizard_validation3.id_tiktok = response.data.data.id_tiktok;
            this.form.sosmed.tiktok = response.data.data.account;
            this.statusProcess = true;
            this.messageProcess = "Success saving data tiktok ...";
          })
          .catch((err) => {
            this.statusProcess = false;
            this.messageProcess = "Failed saving data tiktok ...";
            console.log(err);
          })
          .finally(() => {
            this.updateMediaTarget();
          });
      } else if (site == "Telegram") {
        const tl = { account: username };
        this.statusProcess = "process";
        this.messageProcess = "Scrapping data for telegram ...";
        SocmedService.createTelegram(tl)
          .then((response) => {
            this.wizard_validation3.status = "sent";
            this.wizard_validation3.id_telegram =
              response.data.data.id_telegram;
            this.form.sosmed.telegram = response.data.data.account;
            this.statusProcess = true;
            this.messageProcess = "Success saving data telegram ...";
          })
          .catch((err) => {
            this.statusProcess = false;
            this.messageProcess = "Failed saving data telegram ...";
            console.log(err);
          })
          .finally(() => {
            this.updateMediaTarget();
          });
      } else {
        const other = {
          id_target: this.wizard_validation.id_record,
          site_name: site,
          site_link: link,
          account: username,
        };
        this.statusProcess = "process";
        this.messageProcess = "Scrapping data for another social media ...";
        SocmedService.createOtherSite(other)
          .then((response) => {
            this.wizard_validation3.status = "sent";
            this.wizard_validation3.id_other.push(response.data.data.id_site);
            this.wizard_validation3.sites_name.push(
              response.data.data.site_name
            );
            this.statusProcess = true;
            this.messageProcess = "Success saving data social media ...";
          })
          .catch((err) => {
            this.statusProcess = false;
            this.messageProcess = "Failed saving data social media ...";
            console.log(err);
          })
          .finally();
      }
    },
    /** ======================================*/

    /* =======================================
         handle for updating selected media
         =======================================
      */
    updateMediaTarget() {
      const mediaId = new FormData();
      mediaId.append("id_telegram", this.wizard_validation3.id_telegram);
      mediaId.append("id_twitter", this.wizard_validation3.id_twitter);
      mediaId.append("id_facebook", this.wizard_validation3.id_facebook);
      mediaId.append("id_instagram", this.wizard_validation3.id_instagram);
      mediaId.append("id_tiktok", this.wizard_validation3.id_tiktok);
      // mediaId.append("id_others", this.wizard_validation3.id_other);
      TargetService.update(this.wizard_validation.id_record, mediaId)
        .then((response) => {
          this.statusProcess = true;
          this.messageProcess = "Success updating target";
          setTimeout(() => {
            this.loadingProcess = false;
          }, 500);
        })
        .catch((err) => {
          this.statusProcess = false;
          this.messageProcess = "Failed updating target";
          setTimeout(() => {
            this.loadingProcess = false;
          }, 500);
          console.log(err);
        })
        .finally();
    },
    updateMediaByType(site, username, link) {
      if (site == "Twitter") {
        const args = {
          args: username,
        };
        this.statusProcess = "process";
        this.messageProcess = "Scrapping data for twitter ...";
        TwintService.getUser(args)
          .then((response) => {
            if (response.status == 200) {
              const tw = {
                account: response.data.output.screen_name,
                user_id: response.data.output.user_id,
                name: response.data.output.name,
                avatar: response.data.output.avatar,
                followers: response.data.output.followers,
                following: response.data.output.following,
                tweets: response.data.output.tweets,
                location: response.data.output.location,
                bio: response.data.output.bio,
                likes: response.data.output.likes,
                media: response.data.output.media,
                favorites: response.data.output.favorites,
                is_private: response.data.output.private,
                is_verified: response.data.output.verified,
                join_at: response.data.output.created_at,
              };
              SocmedService.updateTwitter(
                this.wizard_validation3.id_twitter,
                tw
              )
                .then((response) => {
                  this.wizard_validation3.status = "sent";
                  this.form.sosmed.twitter = response.data.data.account;
                  this.statusProcess = true;
                  this.messageProcess = "Success updating data twitter";
                })
                .catch((err) => {
                  this.statusProcess = false;
                  this.messageProcess = "Failed updating data twitter";
                  console.log(err);
                })
                .finally();
            }
          })
          .catch((err) => {
            this.statusProcess = false;
            this.messageProcess = "Failed scrapping data for twitter ...";
            console.log(err);
          })
          .finally();
      } else if (site == "Facebook") {
        const fb = { account: username };
        this.statusProcess = "process";
        this.messageProcess = "Scrapping data for facebook ...";
        SocmedService.updateFacebook(this.wizard_validation3.id_facebook, fb)
          .then((response) => {
            this.wizard_validation3.status = "sent";
            this.form.sosmed.facebook = response.data.data.account;
            this.statusProcess = true;
            this.messageProcess = "Success updating data facebook";
          })
          .catch((err) => {
            this.statusProcess = false;
            this.messageProcess = "Failed updating data facebook";
            console.log(err);
          })
          .finally();
      } else if (site == "Instagram") {
        const ig = { account: username };
        this.statusProcess = "process";
        this.messageProcess = "Scrapping data for instagram ...";
        SocmedService.updateInstagran(this.wizard_validation3.id_instagram, ig)
          .then((response) => {
            this.wizard_validation3.status = "sent";
            this.form.sosmed.instagram = response.data.data.account;
            this.statusProcess = true;
            this.messageProcess = "Success updating data instagram ...";
          })
          .catch((err) => {
            this.statusProcess = false;
            this.messageProcess = "Failed updating data instagram ...";
            console.log(err);
          })
          .finally();
      } else if (site == "Tiktok") {
        const tk = { account: username };
        this.statusProcess = "process";
        this.messageProcess = "Scrapping data for tiktok ...";
        SocmedService.updateTiktok(this.wizard_validation3.id_tiktok, tk)
          .then((response) => {
            this.wizard_validation3.status = "sent";
            this.form.sosmed.tiktok = response.data.data.account;
            this.statusProcess = true;
            this.messageProcess = "Success updating data tiktok ...";
          })
          .catch((err) => {
            this.statusProcess = false;
            this.messageProcess = "Failed updating data tiktok ...";
            console.log(err);
          })
          .finally();
      } else if (site == "Telegram") {
        const tl = { account: username };
        this.statusProcess = "process";
        this.messageProcess = "Scrapping data for telegram ...";
        SocmedService.updateTelegram(this.wizard_validation3.id_telegram, tl)
          .then((response) => {
            this.wizard_validation3.status = "sent";
            this.form.sosmed.telegram = response.data.data.account;
            this.statusProcess = true;
            this.messageProcess = "Success updating data telegram ...";
          })
          .catch((err) => {
            this.statusProcess = false;
            this.messageProcess = "Failed updating data telegram ...";
            console.log(err);
          })
          .finally();
      } else {
        const other = {
          id_target: this.wizard_validation.id_record,
          site_name: site,
          site_link: link,
          account: username,
        };
        this.statusProcess = "process";
        this.messageProcess = "Scrapping data for another social media ...";
        for (let i = 0; i < this.wizard_validation3.sites_name.length; i++) {
          if (this.wizard_validation3.sites_name[i] == site) {
            SocmedService.updateOtherSite(
              this.wizard_validation3.id_other[i],
              other
            )
              .then((response) => {
                this.wizard_validation3.status = "sent";
                this.statusProcess = true;
                this.messageProcess = "Success updating data social media ...";
              })
              .catch((err) => {
                this.statusProcess = false;
                this.messageProcess = "Failed updating data social media ...";
                console.log(err);
              })
              .finally();
          }
        }
      }
    },
    /** ======================================*/

    /* =======================================
          validation next button wizard 3
          =======================================
      */
    validationWizard3: async function (tab) {
      let flag = false;
      let timeout = this.selectedMedsos.length * 1000 - 500;
      await this.saveMedia();
      await new Promise((resolve, reject) => {
        setTimeout(() => {
          flag = true;
          resolve("valid");
        }, timeout);
      }).then();

      return flag;
    },
    /** ======================================*/
    //================================== wizard 3 ===================================//

    //================================== wizard 4 ===================================//
    /* =======================================
         get website info
         =======================================
      */
    async savePrivateWeb() {
      var data = {
        id_target: this.wizard_validation.id_record,
        domain: this.domainSearch,
        id_ip: this.idIp,
        id_web_info: this.idWebInfo,
        id_whois: this.idWhois,
        id_web_service: this.idWebService,
        id_cms: this.idCms,
      };
      await WebsiteService.createPrivateWeb(data)
        .then((response) => {
          this.idPrivateWeb = response.data.data.id_private_web;
          this.messageProcess =
            "Almost done, completing website information gathering...";
          console.log("success save private web", response);
        })
        .catch((err) => {
          this.messageProcess =
            "!Something went wrong, failed completing website information gathering...";
          console.log("err save private web ", err);
        })
        .finally();
    },
    /** ======================================*/

    /* =======================================
         get website info
         =======================================
      */
    async getWebsiteInfo() {
      this.searchResultWebinfo = [];
      const query = {
        website: this.domainSearch,
      };
      await WebsiteService.searchWebInfo(query)
        .then((response) => {
          this.searchResultWebinfo = response.data.output;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally();

      var data = {
        domain_name: this.domainSearch,
        visitors: this.searchResultWebinfo.visitors,
        ip_address: this.searchResultWebinfo.ip_address,
        link_ipv6_address: this.searchResultWebinfo.link_ipv6_address,
        ip_location: this.searchResultWebinfo.ip_location,
        ip_reverse_dns: this.searchResultWebinfo.ip_reverse_dns,
        hosting_company: this.searchResultWebinfo.hosting_company,
        hosting_ip_range: this.searchResultWebinfo.hosting_ip_range,
        hosting_address: this.searchResultWebinfo.hosting_address,
        hosting_country: this.searchResultWebinfo.hosting_country,
        hosting_phone: this.searchResultWebinfo.hosting_phone,
        hosting_website: this.searchResultWebinfo.hosting_website,
        cidr: this.searchResultWebinfo.cidr,
        hosting_cidr: this.searchResultWebinfo.hosting_cidr,
      };
      await WebsiteService.createWebInfo(data)
        .then((response) => {
          this.idWebInfo = response.data.data.id_web_info;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally();

      var query2 = {
        website: this.domainSearch,
      };
      await WebsiteService.searchSubDomain(query2)
        .then((response) => {
          this.searchResultSubDomain = response.data.output;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally();

      var data2 = {
        id_web_info: this.idWebInfo,
        subdomain: JSON.stringify(this.searchResultSubDomain),
      };
      await WebsiteService.createSubDomain(data2)
        .then((response) => {})
        .catch((err) => {
          console.log(err);
        })
        .finally();
    },
    /** ======================================*/

    /* =======================================
         get whois lookup
         =======================================
      */
    async getWhois() {
      this.searchResultWhois = [];
      const query = {
        website: this.domainSearch,
      };
      await WebsiteService.searchDomainWhois(query)
        .then((response) => {
          this.searchResultWhois = response.data.output;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally();

      var data = {
        domain_name: this.searchResultWhois.domainName,
        created_date: this.searchResultWhois.createdDate,
        expired_date: this.searchResultWhois.expiresDate,
        contact_email: this.searchResultWhois.contact_email,
        registran_name: this.searchResultWhois.registrant_name,
        registran_organization: this.searchResultWhois.registrant_organization,
        registran_street: this.searchResultWhois.registrant_street,
        registran_city: this.searchResultWhois.registrant_city,
        registran_state: this.searchResultWhois.registrant_state,
        registran_postal_code: this.searchResultWhois.registrant_postalCode,
        registran_country: this.searchResultWhois.registrant_host_contry,
        registran_email: this.searchResultWhois.registrant_email,
        registran_phone: this.searchResultWhois.registrant_telephone,
        registran_fax: this.searchResultWhois.registrant_fax,
        admin_name: this.searchResultWhois.admin_name,
        admin_organization: this.searchResultWhois.admin_organization,
        admin_street: this.searchResultWhois.admin_street,
        admin_city: this.searchResultWhois.admin_city,
        admin_state_province: this.searchResultWhois.admin_city,
        admin_postal_code: this.searchResultWhois.admin_postalCode,
        admin_country: this.searchResultWhois.admin_countryCode,
        admin_email: this.searchResultWhois.admin_email,
        admin_phone: this.searchResultWhois.admin_telephone,
        admin_fax: this.searchResultWhois.admin_fax,
        tech_name: this.searchResultWhois.tech_name,
        tech_organization: this.searchResultWhois.tech_organization,
        tech_street: this.searchResultWhois.tech_street,
        tech_city: this.searchResultWhois.tech_city,
        tech_state_province: this.searchResultWhois.tech_state,
        tech_postal_code: this.searchResultWhois.tech_postalCode,
        tech_country: this.searchResultWhois.tech_host_contry,
        tech_email: this.searchResultWhois.tech_email,
        tech_phone: this.searchResultWhois.tech_telephone,
        tech_fax: this.searchResultWhois.tech_fax,
      };
      await WebsiteService.createWebWhois(data)
        .then((response) => {
          this.idWhois = response.data.data.id_whois;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally();
    },
    /** ======================================*/

    /* =======================================
         get ip location
         =======================================
      */
    async getIpLocation() {
      this.searchResultIpLocation = [];
      const query = {
        website: this.domainSearch,
      };
      await WebsiteService.searchDomainLocation(query)
        .then((response) => {
          this.searchResultIpLocation = response.data.output;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally();

      var data = {
        domain_name: this.domainSearch,
        ip_address: this.searchResultIpLocation.ip,
        version: this.searchResultIpLocation.version,
        city: this.searchResultIpLocation.city,
        region: this.searchResultIpLocation.region,
        region_code: this.searchResultIpLocation.region_code,
        country: this.searchResultIpLocation.country,
        country_name: this.searchResultIpLocation.country_name,
        country_code: this.searchResultIpLocation.country_code,
        country_code_iso3: this.searchResultIpLocation.country_code_iso3,
        country_capital: this.searchResultIpLocation.country_code_iso3,
        country_tld: this.searchResultIpLocation.country_tld,
        continent_code: this.searchResultIpLocation.continent_code,
        in_ue: this.searchResultIpLocation.in_eu,
        postal_code: this.searchResultIpLocation.postal,
        latitude: this.searchResultIpLocation.latitude,
        longitude: this.searchResultIpLocation.longitude,
        timezone: this.searchResultIpLocation.timezone,
        utc_offset: this.searchResultIpLocation.ip,
        country_calling_code: this.searchResultIpLocation.ip,
        currency: this.searchResultIpLocation.currency,
        currency_name: this.searchResultIpLocation.currency_name,
        languages: this.searchResultIpLocation.languages,
        country_area: this.searchResultIpLocation.country_area,
        country_population: this.searchResultIpLocation.country_population,
        asn: this.searchResultIpLocation.asn,
        org: this.searchResultIpLocation.org,
      };
      await WebsiteService.createWebInfoLocation(data)
        .then((response) => {
          this.idIp = response.data.data.id_ip;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally();
    },
    /** ======================================*/

    /* =======================================
         get service checker
         =======================================
      */
    async getServiceChecker() {
      this.searchResultService = [];
      const query = {
        website: this.domainSearch,
      };
      await WebsiteService.searchWebService(query)
        .then((response) => {
          this.searchResultService = response.data.output;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally();

      var data = {
        domain_name: this.domainSearch,
        ftp: this.searchResultService[0].status,
        ssh: this.searchResultService[1].status,
        telnet: this.searchResultService[2].status,
        smtp: this.searchResultService[3].status,
        whois: this.searchResultService[4].status,
        dns: this.searchResultService[5].status,
        dhcp: this.searchResultService[6].status,
        http: this.searchResultService[7].status,
        pop3: this.searchResultService[8].status,
        sftp: this.searchResultService[9].status,
        nntp: this.searchResultService[10].status,
        ntp: this.searchResultService[11].status,
        netbios: this.searchResultService[12].status,
        imap: this.searchResultService[13].status,
        snmp: this.searchResultService[14].status,
        imap3: this.searchResultService[15].status,
        ldap: this.searchResultService[16].status,
        ssl: this.searchResultService[17].status,
        oracle_sql: this.searchResultService[18].status,
        nfs: this.searchResultService[19].status,
        mysql: this.searchResultService[20].status,
        vnc: this.searchResultService[21].status,
        http2: this.searchResultService[22].status,
      };
      await WebsiteService.createWebService(data)
        .then((response) => {
          this.idWebService = response.data.data.id_web_service;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally();
    },
    /** ======================================*/

    /* =======================================
         get cms checker
         =======================================
      */
    async getCmsChecker() {
      this.searchResultCms = [];
      const query = {
        website: this.domainSearch,
      };
      await WebsiteService.searchWebCms(query)
        .then((response) => {
          this.searchResultCms = response.data.output;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally();

      var data = {
        domain_name: this.domainSearch,
        result: JSON.stringify(this.searchResultCms.result),
        social_media: JSON.stringify(this.searchResultCms.social_media),
      };
      await WebsiteService.createWebCmsChecker(data)
        .then((response) => {
          this.idCms = response.data.data.id_cms;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally();
    },
    /** ======================================*/

    /* =======================================
         get phone number information
         =======================================
      */
    getPhoneInfo() {
      const data = {
        number: this.form.telephone,
      };
      this.phoneinfo = [];
      this.loading = true;
      PhoneService.info(data)
        .then((response) => {
          this.phoneinfo.push(response.data.output);
          this.validformat = response.data.valid;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    /** ======================================*/

    /* =======================================
         save private data information
         =======================================
      */
    savePrivateData() {
      if (this.phoneinfo != 0) {
        const data = {
          email: "",
          phone: this.form.telephone,
          phone_international_format: this.phoneinfo[0].international_format,
          phone_local_format: this.phoneinfo[0].local_format,
          phone_country_code: this.phoneinfo[0].country_code,
          phone_location: this.phoneinfo[0].location,
          phone_carrier: this.phoneinfo[0].carrier,
          phone_area: this.phoneinfo[0].area,
          phone_timezone: this.phoneinfo[0].timezone,
          phone_possibility: this.phoneinfo[0].possibility,
        };
        SocmedService.createPrivateData(data)
          .then((response) => {
            this.wizard_validation4.id_private_data =
              response.data.data.id_private_data;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    /** ======================================*/

    /* =======================================
         finishing wizard
         =======================================
      */
    async finishWizard() {
      this.disableFinish = true;
      this.loadingProcess = true;
      this.statusProcess = "process";
      this.messageProcess = "Please wait, Saving final information target...";
      await (this.domainSearch = this.normalizeUrl());
      await this.savePrivateData();
      if (this.domainSearch != "") {
        await setTimeout(() => {
          this.messageProcess = "Please wait, Getting website information...";
        }, 1000);
        await this.getWebsiteInfo();
        await this.getWhois();
        await this.getIpLocation();
        await this.getServiceChecker();
        await this.getCmsChecker();
        await this.savePrivateWeb();
      }

      let id_private_data = "";
      id_private_data = this.wizard_validation4.id_private_data;
      const formUpdate = new FormData();
      formUpdate.append("status_id", 2);
      formUpdate.append("id_category", this.form.wizard1.category);
      formUpdate.append("id_private_data", id_private_data);
      formUpdate.append(
        "id_private_web",
        this.domainSearch != "" ? this.idPrivateWeb : null
      );
      await TargetService.update(this.wizard_validation.id_record, formUpdate)
        .then((response) => {
          this.statusProcess = true;
          this.messageProcess = "Success saving all target information";
          setTimeout(() => {
            this.loadingProcess = false;
          }, 500);
          Vue.swal({
            position: "top-end",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.disableFinish = false;
          this.phoneinfo = [];
          this.$router.push("/project");
        })
        .catch((err) => {
          this.statusProcess = true;
          this.messageProcess = "Failed saving all target information";
          setTimeout(() => {
            this.loadingProcess = false;
          }, 500);
          this.disableFinish = false;
          console.log(err);
        });
    },
    /** ======================================*/
    //================================== wizard 4 ===================================//

    //================================== support ===================================//
    getPreferences() {
      PreferenceService.getAllElastic()
        .then((response) => {
          this.elastic = response.data.data[0].ip_address;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    parseUrl(url) {
      let loc = new URL(url);
      let url_icon = "";
      switch (loc.host) {
        case "www.capfriendly.com":
          url_icon =
            loc.protocol +
            "//" +
            loc.host +
            "/assets/images/favicons/favicon.ico";
          break;

        default:
          url_icon = loc.protocol + "//" + loc.host + "/favicon.ico";
          break;
      }
      return url_icon;
    },
    generateCharAvatar(name) {
      name.split(/(?=[A-Z])/);
      if (name.length > 1) {
        return name[0].charAt(0) + name[1].charAt(0);
      } else {
        return name[0].charAt(0);
      }
    },
    next() {
      this.$refs.formwizard.nextTab();
    },
    updateTarget(data) {
      TargetService.update(this.wizard_validation.id_record, data)
        .then((response) => {})
        .catch((err) => {
          console.log(err);
        });
    },
    resetTable() {
      this.tableData = [];
    },
    typeForm(e) {
      this.typesubmit = true;
      this.$v.$touch();
    },
    formatDate(value) {
      return moment(value).format("YYYY-MM-DD");
    },
    refreshSlider() {
      this.$watch(
        () => this.$refs.formwizard.activeTabIndex,
        () => {
          if (this.$refs.formwizard.activeTabIndex == 1) {
            this.$refs.slidebar.refresh();
          }
        }
      );
    },
    randomColor(idx) {
      let color = "";
      switch (idx) {
        case 1:
          color = "primary";
          break;
        case 2:
          color = "dark";
          break;
        case 3:
          color = "danger";
          break;
        case 4:
          color = "warning";
          break;
        case 5:
          color = "success";
          break;
        default:
          color = "secondary";
          break;
      }
      return color;
    },
    handleResize() {
      this.screen.width = window.innerWidth;
      this.screen.height = window.innerHeight;
    },
    normalizeUrl() {
      if (this.form.website != "") {
        try {
          let url = new URL(this.form.website);
          return url.host.replace("www.", "");
        } catch (error) {
          return this.form.website;
        }
      } else {
        return "";
      }
    },
    //================================== support ===================================//
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  beforeMount() {
    this.getPreferences();
    this.listProfile();
  },
  mounted() {
    this.$gmapApiPromiseLazy().then(() => {
      if (this.google) {
        this.geocoder = new this.google.maps.Geocoder();
      }
    });
    this.availableOptions;
    this.totalRows = this.items.length;
    this.search_value = 100;
    this.getCategory();
    this.getUser();
  },
};
</script>

<style scoped>
.par {
  position: relative;
}

.cursor-pointer:hover {
  cursor: pointer;
}
.header-accordion-result:hover {
  cursor: pointer;
}
#tab-username {
  padding: 0;
}
</style>
